import NormalFeed from '@/components/NormalFeed'
import { unwrappedFeedAtom } from '@/atoms/feed'
import { useCurrentPubkey } from '@/atoms/session'
import { TFeedSubRequest } from '@/types'
import { useAtomValue } from 'jotai'
import { unwrappedFollowListAtom } from '@/atoms/lists'
import { useState } from 'react'
import { useAsync } from 'react-use'

export default function FollowingFeed() {
  const pubkey = useCurrentPubkey()
  const followList = useAtomValue(unwrappedFollowListAtom) ?? []
  const feed = useAtomValue(unwrappedFeedAtom)
  const [subRequests, setSubRequests] = useState<TFeedSubRequest[]>([])

  useAsync(async () => {
    if (!pubkey) return
    if (!feed || !('pubkey' in feed)) {
      setSubRequests([])
      return
    }

    const following = [...followList]
    if (!following.includes(pubkey)) following.push(pubkey)

    // no need to call outbox.sync() here since that will already happen on NostrProvider
    // for people that the current logged user follows
    setSubRequests([
      {
        source: 'local',
        filter: {
          authors: following
        }
      }
    ])
  }, [feed, pubkey, followList])

  return <NormalFeed subRequests={subRequests} />
}
